LogoutController.$inject = ["Authentication.LogoutServices", "$state", "$auth"];

function LogoutController(LogoutServices, state, auth) {

    var self = this;
    let user = auth.user();

    const afterLogout = function () {
        auth.logOut()
        state.go("Authentication.Login");
    }

    if (!user) {
        afterLogout();
        return
    }

    const logoutHandler = async function () {
        let parameter = {
            type: "logout",
        };

        await LogoutServices.get(parameter).$promise.then(
            response => { },
            errResponse => {
                iziToast.show({
                    message: errResponse.data.message,
                    theme: "light",
                    color: "red"
                });
            }
        ).finally(() => {
            afterLogout();
        });
    };

    logoutHandler();

}

module.exports = ngModule => {

    ngModule.controller('Authentication.LogoutController', LogoutController);

};